const HEX_REGEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

/** Normalize API `hex_value` to `#RRGGBB` or `null` if missing/invalid. */
export function normalizeInventoryHex(
  hexValue: string | null | undefined
): string | null {
  if (hexValue == null || typeof hexValue !== 'string') {
    return null;
  }
  const t = hexValue.trim();
  if (!t) {
    return null;
  }
  const withHash = t.startsWith('#') ? t : `#${t}`;
  if (!HEX_REGEX.test(withHash)) {
    return null;
  }
  if (withHash.length === 4) {
    const [, r, g, b] = withHash;
    return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
  }
  return withHash.toUpperCase();
}

/** CSS `backgroundColor` from API hex, or neutral placeholder when absent. */
export function swatchBackgroundFromHex(
  hexValue: string | null | undefined
): string {
  return normalizeInventoryHex(hexValue) ?? '#9ca8b6';
}

export function formatHexLabel(hexValue: string | null | undefined): string {
  const n = normalizeInventoryHex(hexValue);
  return n ?? 'N/A';
}

export function rgbDisplayFromHex(hexValue: string | null | undefined): string {
  const n = normalizeInventoryHex(hexValue);
  if (!n) {
    return 'N/A';
  }
  const raw = n.replace('#', '');
  const r = Number.parseInt(raw.slice(0, 2), 16);
  const g = Number.parseInt(raw.slice(2, 4), 16);
  const b = Number.parseInt(raw.slice(4, 6), 16);
  return `${r} / ${g} / ${b}`;
}
